import {useTranslation} from "react-i18next";
import {useSnackbar} from "notistack";
import React from "react";
import {makeRequest} from "../../../services/requestService";
import {API_URL} from "../../../constants";
import {Box, Button, FormControlLabel, Grid, Switch, TextField} from "@mui/material";
import PropTypes from "prop-types";

export default function CreateTagsCollection({onSubmit, mode, defaultValue, id}) {
    const {t} = useTranslation('common');
    const {enqueueSnackbar} = useSnackbar();
    const [state, setState] = React.useState(defaultValue ?? {
        name: "",
        description: "",
        private: false
    });

    const submit = () => {
        if (mode === "EDIT") {
            makeRequest(`${API_URL}/label/set/${id}`, "PUT", state).then((response) => {
                if (response.status === 200) {
                    enqueueSnackbar(response.data.message, {variant: "success"});
                    onSubmit();
                }
            })
        } else {
            makeRequest(`${API_URL}/label/set`, "POST", state).then((response) => {
                if (response.status === 201) {
                    enqueueSnackbar(response.data.message, {variant: "success"});
                    onSubmit();
                }
            });
        }
    }

    const handleNameChange = (event) => {
        setState(prevState => {
            let newState = {...prevState};
            newState.name = event.target.value;
            return newState;
        });
    }

    const handleDescriptionChange = (event) => {
        setState(prevState => {
            let newState = {...prevState};
            newState.description = event.target.value;
            return newState;
        });
    }

    const togglePrivate = () => {
        setState(prevState => {
            let newState = {...prevState};
            newState.private = !prevState.private;
            return newState;
        });
    }

    return (
        <Box m={1}>
            <Grid container spacing={2}>
                <Grid item xs={12}>
                    <TextField
                        fullWidth
                        color="secondary"
                        placeholder={t("main.pages.profile.annotation.set.card.title")}
                        variant="standard"
                        value={state.name}
                        type="text"
                        required
                        onChange={handleNameChange}
                    />
                </Grid>
                <Grid item xs={12}>
                    <TextField
                        fullWidth
                        color="secondary"
                        placeholder={t("main.pages.profile.annotation.set.card.desc")}
                        label={t("main.pages.profile.annotation.set.card.desc")}
                        size="small"
                        value={state.description}
                        type="text"
                        onChange={handleDescriptionChange}
                    />
                </Grid>
                <Grid item xs={12}>
                    <FormControlLabel
                        control={<Switch checked={state.private}/>}
                        label={t("main.components.button.private")}
                        onChange={() => togglePrivate()}/>
                </Grid>
                <Grid item xs={12}>
                    <Button
                        type="submit"
                        fullWidth
                        variant="contained"
                        color="primary"
                        onClick={() => submit()}
                    >
                        {t('main.components.saveDialog.save')}
                    </Button>
                </Grid>
            </Grid>
        </Box>
    );
}

CreateTagsCollection.propTypes = {
    onSubmit: PropTypes.func,
    mode: PropTypes.oneOf(["EDIT", "CREATE"]),
    defaultValue: PropTypes.shape({
        name: PropTypes.string,
        description: PropTypes.string,
        private: PropTypes.bool,
    })
}

CreateTagsCollection.defaultProps = {
    onSubmit: () => {
    }
}
